import { useState } from "react";
import { Box } from "@mui/material";
import { CabButton } from "@CabComponents/CabButton";
import { CabDropdown } from "@CabComponents/CabDropdown";
import { CabModal } from "@CabComponents/CabModal";
import { CabToggleChip } from "@CabComponents/CabToggleChip";
import { Tag, RelationshipTag } from "../../store/cabinetApi/generated/crm";

export type TagOption = Tag | RelationshipTag;

export type BulkAddTagsModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  tagOptions: TagOption[];
  onApply: (tagIds: number[]) => void;
};

export const BulkAddTagsModal = ({
  open,
  onClose,
  title,
  tagOptions,
  onApply
}: BulkAddTagsModalProps) => {
  const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);

  const handleClose = () => {
    setSelectedTagIds([]);
    onClose();
  };

  const handleApply = () => {
    if (selectedTagIds.length > 0) {
      onApply(selectedTagIds);
    }
    handleClose();
  };

  const options = tagOptions.map((tag) => ({
    value: tag.id,
    label: tag.color ? (
      <CabToggleChip chipColor={tag.color} label={tag.name} selected />
    ) : (
      tag.name
    )
  }));

  return (
    <CabModal open={open} onClose={handleClose} title={title} closeIcon>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}>
        <CabDropdown<number>
          multiple
          options={options}
          value={selectedTagIds}
          onChange={(e) =>
            setSelectedTagIds(
              Array.isArray(e.target.value) ? e.target.value : []
            )
          }
          placeholder="Select tags to add..."
          sx={{ width: "100%", minWidth: 280 }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1
          }}>
          <CabButton buttonType="secondary" onClick={handleClose}>
            Cancel
          </CabButton>
          <CabButton onClick={handleApply} disabled={selectedTagIds.length === 0}>
            Apply
          </CabButton>
        </Box>
      </Box>
    </CabModal>
  );
};
